// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".avatar-guest{width:40px;height:40px}.avatar-guest .a{fill:#004f95}", ""]);
// Exports
module.exports = exports;
